import React from 'react';

const PlatformStatsPanel = ({ platformData, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="space-y-3">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900">Platform Statistics</h3>
        <span className="text-sm text-gray-500">
          {platformData?.timestamp ? new Date(platformData.timestamp).toLocaleTimeString() : 'Loading...'}
        </span>
      </div>

      <div className="space-y-6">
        {/* Jobs Statistics */}
        <div>
          <div className="text-sm font-semibold text-gray-700 mb-3">Jobs Processed</div>
          <div className="grid grid-cols-3 gap-3">
            <div className="text-center bg-blue-50 p-3 rounded-lg">
              <div className="text-2xl font-bold text-blue-600">
                {platformData?.jobs?.total || 0}
              </div>
              <div className="text-xs text-gray-600">Total</div>
            </div>
            <div className="text-center bg-green-50 p-3 rounded-lg">
              <div className="text-2xl font-bold text-green-600">
                {platformData?.jobs?.today || 0}
              </div>
              <div className="text-xs text-gray-600">Today</div>
            </div>
            <div className="text-center bg-purple-50 p-3 rounded-lg">
              <div className="text-2xl font-bold text-purple-600">
                {platformData?.jobs?.this_week || 0}
              </div>
              <div className="text-xs text-gray-600">This Week</div>
            </div>
          </div>
        </div>

        {/* Candidates Statistics */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Candidates</div>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-gray-50 p-3 rounded-lg">
              <div className="text-2xl font-bold text-gray-900">
                {platformData?.candidates?.total || 0}
              </div>
              <div className="text-xs text-gray-600">Total Database</div>
            </div>
            <div className="bg-orange-50 p-3 rounded-lg">
              <div className="text-2xl font-bold text-orange-600">
                {platformData?.candidates?.evaluated || 0}
              </div>
              <div className="text-xs text-gray-600">Evaluated</div>
            </div>
          </div>
        </div>

        {/* Communications */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Communications Sent</div>
          <div className="space-y-2">
            {/* Email */}
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
              <div className="flex items-center space-x-2">
                <span className="text-lg">📧</span>
                <span className="text-sm text-gray-700">Emails</span>
              </div>
              <div className="text-right">
                <div className="font-semibold text-gray-900">
                  {platformData?.communications?.email?.total || 0}
                </div>
                <div className="text-xs text-green-600">
                  {platformData?.communications?.email?.success_rate?.toFixed(0) || 0}% success
                </div>
              </div>
            </div>

            {/* Calls */}
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
              <div className="flex items-center space-x-2">
                <span className="text-lg">📞</span>
                <span className="text-sm text-gray-700">Calls</span>
              </div>
              <div className="text-right">
                <div className="font-semibold text-gray-900">
                  {platformData?.communications?.calls?.total || 0}
                </div>
                <div className="text-xs text-green-600">
                  {platformData?.communications?.calls?.success_rate?.toFixed(0) || 0}% completed
                </div>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
              <div className="flex items-center space-x-2">
                <span className="text-lg">💬</span>
                <span className="text-sm text-gray-700">WhatsApp</span>
              </div>
              <div className="text-right">
                <div className="font-semibold text-gray-900">
                  {platformData?.communications?.whatsapp?.total || 0}
                </div>
                <div className="text-xs text-green-600">
                  {platformData?.communications?.whatsapp?.success_rate?.toFixed(0) || 0}% delivered
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Success Rates */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Platform Success Rates</div>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Job Processing</span>
              <span className="font-semibold text-green-600">
                {platformData?.success_rates?.job_processing?.toFixed(0) || 0}%
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Candidate Matching</span>
              <span className="font-semibold text-green-600">
                {platformData?.success_rates?.candidate_matching?.toFixed(0) || 0}%
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Email Delivery</span>
              <span className="font-semibold text-green-600">
                {platformData?.success_rates?.email_delivery?.toFixed(0) || 0}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformStatsPanel;

